// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Tooltip, Toastr, Button, Label, Input } from "@revvsales/components";

// Components Imports
import { CustomSelect } from "../../../../commonComponents";

// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";

// Destructuring
const { updateTempWorkFlowData } = DocumentTemplateActions;

class TempWFActions extends Component {
  _updateState = newState => {
    this.props.updateTempWorkFlowData(
      "tempWFAction",
      newState,
      this.props.index,
    );
  };

  _onAddApprover = () => {
    const cloneState = Object.assign({}, this.props.tempWFAction);
    let isNotEmpty = true;

    // CHECK IF THE LAST APPROVER VALUES IS NOT EMPTY
    if (cloneState.approvers.length > 0) {
      const lastRowIndex = cloneState.approvers.length - 1;
      const tempArray = Object.values(cloneState.approvers[lastRowIndex]);
      if (tempArray.length === 0) {
        isNotEmpty = false;
      } else {
        isNotEmpty = tempArray.every(value => value !== "");
      }
    }

    // ACTIONS BASED ON ABOVE CONDITION
    if (isNotEmpty) {
      cloneState.approvers.push({ id: "", name: "", label: "" });
      this._updateState(cloneState);
    } else {
      Toastr.showToastr({
        type: "warning",
        message: "Kindly add an approver",
        timeout: 3000,
      });
    }
  };

  _onRemoveApprover = index => {
    const cloneState = Object.assign({}, this.props.tempWFAction);
    cloneState.approvers.splice(index, 1);
    this._updateState(cloneState);
  };

  _onInputChange = (field, event) => {
    this._updateState({ [field]: event.target.value });
  };

  _onSelectChange = (field, value, index) => {
    if (index !== undefined) {
      const cloneState = Object.assign({}, this.props.tempWFAction);
      cloneState.approvers[index] = value;
      this._updateState(cloneState);
    } else {
      this._updateState({ [field]: value });
    }
  };

  // FILTER ALREADY ADDED APPROVER FROM THE DROPDOWN OPTION
  _filterSelectedApprover = () => {
    const {
      approversOptions,
      tempWFAction: { approvers },
    } = this.props;

    const approversList = approvers.map(
      approver => approver.name || approver.value,
    );

    return approversOptions.map(approver => {
      const unusedApprovers = approver.options.filter(
        user => !approversList.includes(user.name || user.value),
      );
      approver.options = unusedApprovers;
      return approver;
    });
  };

  render() {
    const {
      tempWFCondition: { conditions = [] },
      tempWFAction: { approvers = [], approvalType = "", triggerMessage = "" },
    } = this.props;

    const formatGroupLabel = data => (
      <div>
        <span>{data.label}</span>
      </div>
    );

    return (
      <div className="wfactions-wrapper">
        <div className="wfactions-title-section">
          <div className="wfactions-icon">
            <FontAwesomeIcon icon={["fas", "magic"]} />
          </div>
          <div className="wfactions-info">
            <div className="wfactions-title">Actions</div>
            <div className="wfactions-subtitle">
              Select or add actions to happen when conditions are met
            </div>
          </div>
        </div>
        {!this.props.isCollapsed && (
          <div>
            {!conditions.length > 0 && (
              <Fragment>
                <div className="wfactions-empty-section no-bottom-border">
                  <div className="wfactions-empty-info">
                    Your workflow doesn&apos;t have an action yet. Select an
                    action from below
                  </div>
                </div>
              </Fragment>
            )}

            {conditions.length > 0 && (
              <div className="tempwfactions-approval-sectionselected">
                <div className="wfconditionslist-list-wrapper">
                  <div className="tempwfactions-approval-titleselected">
                    <span className="wfconditions-title-txt">
                      Approvers and Workflow Message
                    </span>
                  </div>
                  <div className="tempwfactions-approval-body">
                    <div className="wfactions-approvers-list">
                      <div className="choose-doc-source">
                        <span className="choose-doc-sourcetype">
                          <Label>
                            <Input
                              type="radio"
                              name="choose_source"
                              value
                              checked={approvalType === "Sequential"}
                              onChange={() =>
                                this._onSelectChange(
                                  "approvalType",
                                  "Sequential",
                                )
                              }
                              data-test="tempwfactions-sequential-approval-input"
                            />
                            Sequential Approval
                          </Label>
                        </span>
                        <span className="choose-doc-sourcetype">
                          <Label>
                            <Input
                              type="radio"
                              name="choose_source"
                              value
                              checked={approvalType === "Parallel"}
                              onChange={() =>
                                this._onSelectChange("approvalType", "Parallel")
                              }
                              data-test="tempwfactions-parallel-approval-input"
                            />
                            Parallel Approval
                          </Label>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="wfactions-approvers-list">
                      <span className="wfactions-approvers-title">
                        Approvers
                      </span>
                      {approvers.map((user, index) => (
                        <div
                          className="wfactions-approvers-wrapper"
                          key={`${user.type}_${user.id}`}>
                          <CustomSelect
                            className="wfactions-approvers-listitems"
                            isSearchable
                            options={this._filterSelectedApprover()}
                            formatGroupLabel={formatGroupLabel}
                            value={user}
                            onChange={value =>
                              this._onSelectChange("approvers", value, index)
                            }
                            data-test="tempwfactions-customselect"
                          />
                          <span
                            className="wfactions-approvers-removeico"
                            tabIndex="0"
                            role="button"
                            onKeyPress={() => this._onRemoveApprover(index)}
                            onClick={() => this._onRemoveApprover(index)}>
                            <Tooltip placement="top" overlay="Remove Approver">
                              <FontAwesomeIcon icon={["far", "times-circle"]} />
                            </Tooltip>
                          </span>
                        </div>
                      ))}
                    </div>
                    <div className="wfactions-add-wrapper">
                      <Button
                        className="revv-btn-secondary-sm"
                        data-test="tempwfactions-add-approver"
                        onClick={this._onAddApprover}
                        onKeyPress={this._onAddApprover}
                        role="button"
                        tabIndex="0">
                        <i>
                          <FontAwesomeIcon icon={["far", "plus"]} />
                        </i>
                        Add another approver
                      </Button>
                    </div>
                  </div>
                  <div>
                    <div className="wfactions-approvers-list">
                      <div className="wfconditionslist-div-wrapper">
                        <span className="revvform-label">
                          Message displayed on approval trigger
                        </span>
                        <Input
                          placeholder="Enter Message"
                          value={triggerMessage}
                          onChange={event =>
                            this._onInputChange("triggerMessage", event)
                          }
                          data-test="tempwfactions-approvalmsg-input"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    workflow: { users, userGroups },
  } = state.TemplateStore;

  // filter the active users only
  let activeUsers = [];
  if (users && users.length > 0) {
    activeUsers = users.filter(user => user.is_active);
  }

  //* Generate Approvers option containing both user & group data
  const userOptions = activeUsers.map(user => ({
    id: user.id,
    value: user.name,
    label: user.name,
    type: "user",
  }));

  // filter the active groups only
  let activeGroups = [];
  if (userGroups && userGroups.length > 0) {
    activeGroups = userGroups.filter(userGroup => userGroup.active);
  }

  const userGroupOptions = activeGroups.map(user => ({
    id: user.id,
    value: user.name,
    label: user.name,
    type: "group",
  }));

  const approversOptions = [
    {
      label: "Teammates",
      options: userOptions,
    },
    {
      label: "Groups",
      options: userGroupOptions,
    },
  ];

  return {
    approversOptions,
    userGroups,
    users,
  };
};

const mapDispatchToProps = {
  updateTempWorkFlowData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TempWFActions);



// WEBPACK FOOTER //
// ./src/components/Template/TempWorkFlow/TempWFActions/index.js